import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'
import alertGiftImg from '@/assets/landing/alert-gift.png'
import taiChi4049Img from '@/assets/landing-age-selection/tai-chi-40-49.webp'
import taiChi5059Img from '@/assets/landing-age-selection/tai-chi-50-59.webp'
import taiChi6069Img from '@/assets/landing-age-selection/tai-chi-60-69.png'
import taiChi7080Img from '@/assets/landing-age-selection/tai-chi-70-80.png'

const schema: LandingScreenSchema = {
	order: ['LandingAlert', 'LandingTitleExtended', 'LandingAgeGrid'],

	components: {
		LandingAlert: ({ $t }): LandingComponentsConfig['LandingAlert'] => ({
			text: $t('female_yoga.pages.landing.alert_text'),
			icon: alertGiftImg,
			backgroundColor: 'var(--Fill-Accent-16)',
			customStyles: {
				marginTop: 'var(--size-20)',
			},
		}),

		LandingTitleExtended: ({ $t }): LandingComponentsConfig['LandingTitleExtended'] => ({
			title: 'CHAIR Tai Chi<br/>for SENIORS',
			note: $t('female_yoga.pages.landing.quiz'),
		}),

		LandingAgeGrid: ({ $t }): LandingComponentsConfig['LandingAgeGrid'] => ({
			theme: 'purple',
			ageRanges: [
				{
					value: 40,
					analyticValue: '40-49',
					label: $t('female_yoga.pages.landing.age_range.40_49'),
					img: taiChi4049Img,
				},
				{
					value: 50,
					analyticValue: '50-59',
					label: $t('female_yoga.pages.landing.age_range.50_59'),
					img: taiChi5059Img,
				},
				{
					value: 60,
					analyticValue: '60-69',
					label: $t('female_yoga.pages.landing.age_range.60_69'),
					img: taiChi6069Img,
				},
				{
					value: 70,
					analyticValue: '70+',
					label: $t('female_yoga.pages.landing.age_range.70_80'),
					img: taiChi7080Img,
				},
			],
			otherAgesButton: {
				data: { value: 18, analyticValue: '18-39' },
				text: $t('female_yoga.pages.landing.im_young'),
			},
		}),
	},
}

export default schema
